import React from 'react'
import { Link, navigateTo } from 'gatsby-link'

import slugify from '../slugify.js'

const DirectoryList = ({ document, apiSourceUrl }) => (
	<div className="col-md-4" key={document.node.id}>
		<div className="card mb-4 box-shadow">
			<a href={document.node.website_url} className="text-dark" target="_blank">
				<img
					src={`${apiSourceUrl}${document.node.thumbnail.url}`}
					className="card-img-top img-fluid rounded"
				/>
			</a>
			<div className="card-body text-center">
				<div className="card-text mt-3">
					<h5>
						<a
							href={document.node.website_url}
							className="text-dark"
							target="_blank"
						>
							{document.node.title}
						</a>
					</h5>
					{!document.node.free ? (
						<p>
							<span className="badge badge-pill badge-primary">Featured</span>
						</p>
					) : (
						<p>
							<span className="badge badge-pill badge-info">Free</span>
						</p>
					)}
					<p>
						{document.node.body.length > 50
							? document.node.body.substring(0, 50) + '...'
							: document.node.body}
					</p>
				</div>
			</div>
		</div>
	</div>
)

export default DirectoryList



// WEBPACK FOOTER //
// ./src/components/directory-list.js